import CAJA1090ResponseModel from '@/api/data/CAJ/CAJG1090/CAJA1090ResponseModel'
import CAJA1090RequestModel from '@/api/data/CAJ/CAJG1090/CAJA1090RequestModel'
import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'
import CommonUtil from '@/common/utils/CommonUtil'

export default class CAJG1090Service {
  /**
   *
   * @returns string base 64
   */
  public async callAPICAJA1090(): Promise<CAJA1090ResponseModel> {
    const caja1090RequestModel = new CAJA1090RequestModel()
    const caja1090ResponseModel: CAJA1090ResponseModel = <
      CAJA1090ResponseModel
    > await RestService.post(
      CommonUtil.getApiUrl(ApiUrlConstants.CAJA1090),
      caja1090RequestModel
    )
    return caja1090ResponseModel
  }
}
